import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { BookingFlowStep, PootsyButton, ExternalPrimaryLink } from "../DesignFunctions"
import * as actions from "../../actions/acBookingFlow"
import { BookingFlowStep as Step } from "../../actions/acBookingFlow"
import * as residencesActions from '../../actions/acResidences'

import pinVoucher from '../../static/img/pin-voucher.png'
import { PootsyCheckboxInput, PootsyRadioInputs, PootsyTextInput } from "../InputsFunctions"
import ModalLayout from "../shared/ModalLayout"
import NewResidenceForm from "../shared/NewResidenceForm"

class BookingFlowSodexo extends Component {

	componentWillMount = () => {
		let { profile } = this.props
		this.props.dispatch(actions.bookingFlowDataChange({ sodexoNumber: profile.sodexoRef, sodexoRegion: profile.sodexoRegion, alreadyRegisterToSodexo: profile.sodexoRef !== '' }))
	}

	render() {
		let { t } = this.context

		let headerContent = {
			picto: pinVoucher,
			title: t('booking_flow_sodexo_title'),
			subtitle: t('booking_flow_sodexo_input_prompt')
		}

		return (
			<BookingFlowStep customClass="step-sodexo" headerContent={headerContent}>

				<div className="voucher_count_label">
					{t('booking_flow_sodexo_voucher_count_label', { voucher_count: this.props.duration })}
				</div>

				{this.renderAlreadyRegisteredToSodexoRadios()}

				{this.props.alreadyRegisterToSodexo && this.renderAlreadyRegisterToSodexoContainer()}
				{this.props.alreadyRegisterToSodexo !== undefined && !this.props.alreadyRegisterToSodexo && this.renderNotRegisteredToSodexo()}

				<div className="divider"/>

				<div className="bottom">
					<div className="previous-step" onClick={this.goToPreviousStep}>← {t('previous')}</div>
					<PootsyButton
						disabled={!this.isNextButtonEnabled()}
						text={t('next_step')}
						onClick={this.onNextButtonClick}/>
				</div>

				{this.props.showNewResidenceModal && this.renderNewResidenceModal()}

			</BookingFlowStep>
		)
	}

	renderAlreadyRegisteredToSodexoRadios = () => {
		let { t } = this.context

		let options = [
			{
				value: true,
				label: t('yes')
			},
			{
				value: false,
				label: t('no')
			}
		]


		return <PootsyRadioInputs
			selectedValue={this.props.alreadyRegisterToSodexo}
			options={options}
			onChange={this.onAlreadyRegisteredToSodexoChange}/>
	}

	renderAlreadyRegisterToSodexoContainer = () => {
		let { t } = this.context

		return (
			<div className="content">
				{this.renderVoucherTypeSection()}
				{this.renderSodexoRegionSection()}

				<div className="title-container">
					<div className="title">{t('booking_flow_sodexo_number_title')}</div>
					<div className="line"/>
				</div>
				<div className="subtitle">{t('booking_flow_sodexo_number_subtitle')}</div>
				<PootsyTextInput placeholder={t('booking_flow_sodexo_number_placeholder')}
								 value={this.props.sodexoNumber}
								 onChange={this.onSodexoNumberChange}/>
			</div>
		)
	}

	renderNotRegisteredToSodexo = () => {
		let { t } = this.context

		return (
			<div className="content">
				<div className="explainer-container">
					<div className="title">{t('booking_flow_sodexo_explainer_title')}</div>
					<div className="subtitle">{t('booking_flow_sodexo_explainer_subtitle')} <ExternalPrimaryLink to="http://pootsy.be/1800/les-titres-services-mode-demploi/" label={t('booking_flow_sodexo_explainer_subtitle_link')}/>
					</div>
				</div>

				{this.renderVoucherTypeSection()}
				{this.renderSodexoRegionSection()}

				<div className="title-container">
					<div className="title">{t('booking_flow_sodexo_niss_title')}</div>
					<div className="line"/>
				</div>
				<div className="subtitle">{t('booking_flow_sodexo_niss_subtitle')}</div>
				<PootsyTextInput placeholder={t('booking_flow_sodexo_niss_placeholder')}
								 value={this.props.niss ? this.props.niss : ''}
								 onChange={this.onNissChange}/>

				<div className="title-container">
					<div className="title">{t('booking_flow_sodexo_residence_title')}</div>
					<div className="line"/>
				</div>
				<div className="subtitle">{t('booking_flow_sodexo_residence_subtitle')}</div>
				{this.renderResidences()}

				<div className="title-container">
					<div className="title">{t('booking_flow_sodexo_iban_title')}</div>
					<div className="line"/>
				</div>
				<div className="subtitle">{t('booking_flow_sodexo_iban_subtitle')}</div>
				<div className="iban-container">
					<div className="prefix">BE</div>
					<PootsyTextInput onChange={this.onIbanChange}/>
				</div>

				<PootsyCheckboxInput
					label={t('booking_flow_sodexo_terms_label')}
					name="terms"
					checked={this.props.sodexoTermsAccepted}
					onChange={this.onSodexoTermsAcceptedChange}/>
			</div>
		)
	}

	renderVoucherTypeSection = () => {
		let { t } = this.context

		return [
			<div className="title-container" key="0">
				<div className="title">{t('booking_flow_sodexo_voucher_type_title')}</div>
				<div className="line"/>
			</div>,
			<div className="subtitle" key="1">{t('booking_flow_sodexo_voucher_type_subtitle')}</div>,
			this.renderVoucherTypeRadios()
		]
	}

	renderSodexoRegionSection = () => {
		let { t } = this.context

		return [
			<div className="title-container" key="0">
				<div className="title">{t('booking_flow_sodexo_region_title')}</div>
				<div className="line"/>
			</div>,
			<div className="subtitle" key="1">{t('booking_flow_sodexo_region_subtitle')}</div>,
			this.renderSodexoRegionRadios()
		]
	}

	renderVoucherTypeRadios = () => {
		let { t } = this.context

		let options = [
			{
				value: 'electronic',
				label: t('booking_flow_sodexo_voucher_type_electronic')
			},
			{
				value: 'paper',
				label: t('booking_flow_sodexo_voucher_type_paper')
			}
		]


		return <PootsyRadioInputs
			key="VoucherTypeSelection"
			selectedValue={this.props.voucherType}
			options={options}
			onChange={this.onVoucherTypeChange}/>
	}

	renderSodexoRegionRadios = () => {
		let { t } = this.context

		let options = [
			{
				value: 'Bruxelles',
				label: t('sodexo_region_brussels')
			},
			{
				value: 'Vlaanderen',
				label: t('sodexo_region_flanders')
			},
			{
				value: 'Wallonie',
				label: t('sodexo_region_wallonia')
			}
		]


		return <PootsyRadioInputs
			key="SodexoRegionSelection"
			selectedValue={this.props.sodexoRegion}
			options={options}
			onChange={this.onSodexoRegionChange}/>
	}

	renderResidences = () => {
		let { t } = this.context
		let options = []
		this.props.residences.forEach(residence => {
			let address = residence.address
			options.push({
				value: residence.id,
				label: address.streetName + ', ' + address.streetNumber + ' ' + address.zipCode + ' ' + address.city
			})
		})
		options.push({
			value: 'new',
			label: t('booking_flow_sodexo_residence_choose_new')
		})

		return <PootsyRadioInputs
			customItemClass="residence-item"
			selectedValue={this.props.selectedSodexoResidence ? this.props.selectedSodexoResidence.id : ''}
			options={options}
			onChange={this.onResidenceSelected}/>
	}

	renderNewResidenceModal = () => {
		let { t } = this.context

		return (
			<ModalLayout closeModal={this.onCloseNewResidenceModal} customClass="NewResidence">
				<div className="title">{t('booking_flow_sodexo_residence_new_modal_title')}</div>
				<NewResidenceForm/>
				<div className="buttons-container">
					<PootsyButton text={t('continue')}
								  disabled={!this.isNewResidenceNextButtonEnabled()} onClick={this.onNewResidenceNextButtonClick}/>
					<div className="cancel" onClick={this.onCloseNewResidenceModal}>{t('cancel')}</div>
				</div>
			</ModalLayout>
		)
	}

	onAlreadyRegisteredToSodexoChange = (e) => {
		let selectedValue = e.target.dataset.selectedvalue
		this.props.dispatch(actions.bookingFlowMetaChange({ alreadyRegisterToSodexo: selectedValue === 'true' }))
	}

	onVoucherTypeChange = (e) => {
		let selectedValue = e.target.dataset.selectedvalue
		this.props.dispatch(actions.bookingFlowDataChange({ voucherType: selectedValue }))
	}

	onSodexoRegionChange = (e) => {
		let selectedValue = e.target.dataset.selectedvalue
		this.props.dispatch(actions.bookingFlowDataChange({ sodexoRegion: selectedValue }))
	}

	onSodexoNumberChange = (e) => {
		let sodexoNumber = e.target.value
		this.props.dispatch(actions.bookingFlowDataChange({ sodexoNumber: sodexoNumber }))
	}

	onNissChange = (e) => {
		let niss = e.target.value
		this.props.dispatch(actions.bookingFlowDataChange({ niss: niss }))
	}

	onResidenceSelected = (e) => {
		let selectedValue = e.target.dataset.selectedvalue
		if (selectedValue === 'new') {
			this.props.dispatch(actions.bookingFlowMetaChange({ showNewResidenceModal: true }))
		} else {
			let residence = this.props.residences.find(residence => residence.id === selectedValue)
			this.props.dispatch(actions.bookingFlowDataChange({ selectedSodexoResidence: residence }))
		}
	}

	onCloseNewResidenceModal = () => {
		this.props.dispatch(actions.bookingFlowMetaChange({ showNewResidenceModal: false }))
	}

	onIbanChange = (e) => {
		let iban = e.target.value
		this.props.dispatch(actions.bookingFlowDataChange({ iban: iban }))
	}

	onSodexoTermsAcceptedChange = (e) => {
		this.props.dispatch(actions.bookingFlowMetaChange({ sodexoTermsAccepted: e.target.checked }))
	}

	isNewResidenceNextButtonEnabled = () => {
		return this.props.newResidence.streetName && this.props.newResidence.streetNumber && this.props.newResidence.zipCode && this.props.newResidence.city && this.props.newResidence.surface
	}

	onNewResidenceNextButtonClick = () => {
		this.props.dispatch(residencesActions.createResidence())
	}

	isNextButtonEnabled = () => {
		if (this.props.alreadyRegisterToSodexo) {
			return this.props.voucherType && this.props.sodexoRegion && this.props.sodexoNumber
		} else {
			return this.props.voucherType && this.props.sodexoRegion && this.props.niss && this.props.selectedSodexoResidence && this.props.iban && this.props.sodexoTermsAccepted
		}
	}

	goToPreviousStep = () => {
		this.props.dispatch(actions.bookingFlowMetaChange({ currentStep: Step.INFORMATIONS_RESIDENCE }))
	}

	onNextButtonClick = () => {
		this.props.dispatch(actions.bookingFlowValidateSodexoStep())
	}
}

BookingFlowSodexo.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	duration: state.dataReducer.bookingFlow.duration,
	alreadyRegisterToSodexo: state.metadataReducer.bookingFlow.alreadyRegisterToSodexo,
	voucherType: state.dataReducer.bookingFlow.voucherType,
	sodexoRegion: state.dataReducer.bookingFlow.sodexoRegion,
	sodexoNumber: state.dataReducer.bookingFlow.sodexoNumber,
	niss: state.dataReducer.bookingFlow.niss,
	residences: state.dataReducer.residences.residences,
	selectedSodexoResidence: state.dataReducer.bookingFlow.selectedSodexoResidence,
	showNewResidenceModal: state.metadataReducer.bookingFlow.showNewResidenceModal,
	sodexoTermsAccepted: state.metadataReducer.bookingFlow.sodexoTermsAccepted,
	iban: state.dataReducer.bookingFlow.iban,
	newResidence: state.dataReducer.residences.newResidence,
	profile: state.dataReducer.accountProfile
})
export default connect(mapStateToProps)(BookingFlowSodexo);


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowSodexo.js